import { render } from "./Facebook.vue?vue&type=template&id=52d559c2&scoped=true&ts=true"
import script from "./Facebook.vue?vue&type=script&lang=ts"
export * from "./Facebook.vue?vue&type=script&lang=ts"

import "./Facebook.vue?vue&type=style&index=0&id=52d559c2&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d559c2"]])

export default __exports__